import Joi from "joi";

const SubCategorySchema = Joi.object({
  parentCategory: Joi.string().trim().required().messages({
    "string.empty": "Category Name is required.",
  }),
  categoryName: Joi.string().trim().required().messages({
    "string.empty": "Sub Category Name is required.",
  }),
  code: Joi.string().trim().required().messages({
    "string.empty": "Code is required.",
  }),
  isSaleRate: Joi.boolean().required(),
  saleRateBasedOn: Joi.object({
    option: Joi.string().trim().when('..isSaleRate', {
      is: true,
      then: Joi.string().required().messages({
        "string.empty": "Option is required when Sale Rate is enabled.",
      }),
      otherwise: Joi.string().optional()
    }),
    percentage: Joi.number().when('..isSaleRate', {
      is: true,
      then: Joi.number().min(0).max(100).required().messages({
        "number.base": "Percentage must be a number.",
        "number.min": "Percentage cannot be negative.",
        "number.max": "Percentage cannot be more than 100.",
        "any.required": "Percentage is required when Sale Rate is enabled."
      }),
      otherwise: Joi.number().min(0).max(100).optional()
    }),
  }).when('isSaleRate', {
    is: true,
    then: Joi.object().required(),
    otherwise: Joi.object().optional()
  }),
}).unknown(true);

export default SubCategorySchema;
